import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_home_accents: FaireCollectionEntity = {
  token: "col_home-accents",
  type: "collection",
  name: "Home Accents",
  description: "Everyday decorative pieces for any space.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  season: "everyday",
  itemCount: 156,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
